import React from 'react';
export function Logo({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex items-center gap-3 ${className}`} data-id="element-157">
      <div className="relative w-10 h-10 md:w-12 md:h-12 shrink-0 flex items-center justify-center bg-accent rounded-full shadow-[0_0_15px_rgba(57,255,20,0.5)]" data-id="element-158">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 md:w-8 md:h-8 text-dark" data-id="element-159">
          <path d="M12 2C7.58172 2 4 5.58172 4 10C4 14.4183 7.58172 22 12 22C16.4183 22 20 14.4183 20 10C20 5.58172 16.4183 2 12 2ZM8.5 13C7.67157 13 7 11.6569 7 10C7 8.34315 7.67157 7 8.5 7C9.32843 7 10 8.34315 10 10C10 11.6569 9.32843 13 8.5 13ZM15.5 13C14.6716 13 14 11.6569 14 10C14 8.34315 14.6716 7 15.5 7C16.3284 7 17 8.34315 17 10C17 11.6569 16.3284 13 15.5 13Z" fill="currentColor" data-id="element-160" />
        </svg>
      </div>
      <div className="flex flex-col" data-id="element-161">
        <span className="font-display text-xl md:text-2xl text-white leading-none tracking-wider uppercase" data-id="element-162">
          Alien
        </span>
        <span className="text-[10px] md:text-xs text-accent font-bold tracking-[0.2em] uppercase" data-id="element-163">
          Plumbing
        </span>
      </div>
    </div>;
}